import { i18n } from '@/commons/utils';
//---

export function init() {
  initMapsReviewsResize();
  initSlickOpenings();
  initSlickOffers();
  initSlickServices();
  specialHours();

  if (cube.$id('header-store')) cube.cartridge('header-store').reload();

  // IE :(
  if ($('html').hasClass('ie8')) {
    ie8();
  }
}

function initMapsReviewsResize() {
  storeReviews();
  desktopInitMap();
  bindResize();
}

function desktopInitMap() {
  if (!cube.ui.isMobile()) {
    initMap();
  }
}

function bindResize() {
  cube.event.on(
    'resize',
    cube.debounce(
      data => {
        if (!cube.ui.isMobile() && $('#map-bg div').length === 0) {
          initMap(data);
        }
      },
      75,
      true
    )
  );
}

function initMap() {
  if (Cube.Features.useBaiduAsMapProvider()) {
    initMapBaidu();
  } else {
    initMapGoogle();
  }
}

function initMapBaidu() {
  if ($('#call-url').length === 0) return;

  const data = JSON.parse($('#call-url').val());

  createMapBaidu({
    mapId: 'map-bg',
    centerLat: data.latitude,
    centerLng: data.longitude - 1, // The store is displayed at the right of the map.
    zoom: 10,
    storeLat: data.latitude,
    storeLng: data.longitude,
    storeName: data.storeName,
    storeAddress: getStoreAddressFromData(data),
  });
}

function initMapGoogle() {
  if ($('#call-url').length === 0) return;

  const data = JSON.parse($('#call-url').val());

  createMapGoogle({
    mapId: 'map-bg',
    centerLat: data.latitude,
    centerLng: data.longitude - 1, // The store is displayed at the right of the map.
    zoom: 9,
    storeLat: data.latitude,
    storeLng: data.longitude,
    storeName: data.storeName,
    storeAddress: getStoreAddressFromData(data),
  });
}

/**
 *
 *
 * @param {any} data
 */
function createMapBaidu(data) {
  const MyBmap = new window.BMap.Map(document.getElementById('map-bg'));

  // Center Map
  MyBmap.centerAndZoom(
    new window.BMap.Point(data.centerLng, data.centerLat),
    data.zoom
  );

  // Disable dragg and drop on mobile
  if (jQuery('body').hasClass('mobile')) {
    MyBmap.disableDragging();
  }

  // Store location
  const storePoint = new window.BMap.Point(data.storeLng, data.storeLat);

  // Add Info Window
  const template = createMapInfoWindowTemplate(
    data.storeName,
    data.storeAddress
  );
  const infoWindow = new window.BMap.InfoWindow(template);

  // Add store marker
  const icon = new window.BMap.Icon(
    '/assets/images/pin-icon-blue.png',
    new window.BMap.Size(22, 35)
  );
  const marker = new window.BMap.Marker(storePoint, { icon });
  marker.addEventListener('click', () => {
    this.openInfoWindow(infoWindow);
  });
  MyBmap.addEventListener('tilesloaded', () => {
    marker.openInfoWindow(infoWindow);
  });
  MyBmap.addOverlay(marker);
}

/**
 *
 *
 * @param {Object} data
 */
function createMapGoogle(data) {
  // Create and center Map
  const MyGmap = new window.google.maps.Map(document.getElementById('map-bg'), {
    center: { lat: data.centerLat, lng: data.centerLng },
    scrollwheel: false,
    zoom: 9,
    disableDefaultUI: true,
  });

  // Add Info Window
  const template = createMapInfoWindowTemplate(
    data.storeName,
    data.storeAddress
  );
  const infoWindow = new window.google.maps.InfoWindow({
    content: template,
  });

  // Add store marker
  const icon = '/assets/images/pin-icon-blue.png';
  const marker = new window.google.maps.Marker({
    position: { lat: data.storeLat, lng: data.storeLng },
    map: MyGmap,
    icon,
  });
  marker.addListener('click', () => {
    infoWindow.open(MyGmap, marker);
  });
  MyGmap.addListener('tilesloaded', () => {
    infoWindow.open(MyGmap, marker);
  });
}

/**
 *
 *
 * @param {Object} data
 * @returns
 */
function getStoreAddressFromData(data) {
  let template = '';

  template +=
    data.address.address1 !== null ? `${data.address.address1}<br />` : '';
  template += `${data.address.postalCode} ${data.address.city}`;

  return template;
}

/**
 *
 *
 * @param {String} name
 * @param {String} address
 */
function createMapInfoWindowTemplate(name, address) {
  const template = `
  <div class="info-store">
  <div class="content">
  <p class="store-name">${name}</p>
  <p class="store-address">${address}</p>
  </div>
  <div class="store-picture">
  <img src="/assets/images/decathlon-logo.svg" alt="${name}" />
  </div>
  </div>
  `;

  return template;
}

function initSlickOpenings() {
  $('.slick-openings').slick({
    infinite: false,
    arrows: true,
    dots: true,
    useCSS: true,
    useTransform: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
  });
}

function initSlickOffers() {
  $('.slick-offers').slick({
    infinite: false,
    dots: true,
    speed: 300,
    useCSS: true,
    autoplay:true,
    autoplaySpeed:3000,
    useTransform: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: window.decathlon.uxBreakpoints.smMin,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
}

function initSlickServices() {
  let vSlidesToShow = 3;
  let vSlidesToScroll= 3;

  //get the store services count to adapt the slick
  if ($('#services-store-count').length === 0) return;
  const servicesCount = JSON.parse($('#services-store-count').val());

  if(servicesCount < 3){
    vSlidesToScroll = servicesCount;
    vSlidesToShow = servicesCount;
  }

  $('.slick-store-services').slick({
    infinite: false,
    dots: true,
    speed: 300,
    useCSS: true,
    useTransform: true,
    autoplay:true,
    autoplaySpeed:5000,
    slidesToShow: vSlidesToShow,
    slidesToScroll: vSlidesToScroll,
    responsive: [
      {
        breakpoint: window.decathlon.uxBreakpoints.smMin,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      }
    ],
  });
}

function ie8() {
  const windowWidth = $(window).width();

  const dynamicWidth = window.decathlon.uxBreakpoints.lgMin * (2 / 3);
  // positioning the top element
  if (windowWidth >= window.decathlon.uxBreakpoints.lgMin) {
    const leftPos = (windowWidth - window.decathlon.uxBreakpoints.lgMin) / 2;
    $('.st-p-wrapper.top').css({
      left: `${leftPos}px`,
      width: `${dynamicWidth}px`,
    });
  } else {
    $('.st-p-wrapper.top').css({
      left: '15px',
      width: `${dynamicWidth}px`,
    });
  }
}

/**
 *
 *
 * @param {Boolean} bool
 */
function storeReviewsMoveRatings(bool) {
  $('.panel-review-user-smiley').each((i, elt) => {
    const $target = $(elt);
    const $fields = $target.find('.fields');
    let $to = null;

    if (bool) {
      $to = $target.find('.review-info > #criteria-container');
    } else {
      $to = $target.find('.sidebar');
    }

    $fields.detach().appendTo($to);
  });
}

function storeReviews() {
  const mobile = $('body').hasClass('mobile');
  storeReviewsMoveRatings(mobile);

  $(window).resize(() => {
    const width = $('body').width();
    storeReviewsMoveRatings(width < 769);
  });
}

function specialHours() {
  if ($('#call-url').length === 0) return;

  const dataHours = JSON.parse($('#call-url').val());

  const idstore = dataHours.storeId;

  cube.stores.searchStores({  idstore }, dataStores => {
    const localDaysNames = [
      'day.Monday',
      'day.Tuesday',
      'day.Wednesday',
      'day.Thursday',
      'day.Friday',
      'day.Saturday',
      'day.Sunday',
    ].map(i18n);

    function displayHour(hour) {
      let hourArr = 0;
      if (hour) {
        hourArr = hour.split(':');
      }
      const hours = parseInt(hourArr[0], 10);
      const minutes = hourArr[1];
      return `<big>${hours}</big>:<small>${minutes}</small>`;
    }

    function displayDayOpening(dayData) {
      const dayname = localDaysNames[dayData.dayIndex];
      let hourStart = 0;
      let hourEnd = 0;
      let isSpecial = '';

      if (dayData.isSpecial) {
        isSpecial = 'isSpecialHours';
      }

      if (
        dayData.hours &&
        dayData.hours.length > 0 &&
        dayData.hours[0].start &&
        dayData.hours[0].end
      ) {
        if(dayData.hours.length === 2) {
          const schedule = dayData.hours;
          const allSchedule =  [];

          schedule.forEach( (element) => {
            hourStart = displayHour(element.start);
            hourEnd = displayHour(element.end);

            const item = `${hourStart} - ${hourEnd}`;
            allSchedule.push(item);
          });

          return `
            <li>
              <span class="day">${dayname}</span>
              <span class="schedule ${isSpecial}">
                ${allSchedule.toString().replace(',', ' / ')}
              </span>
            </li>
          `;
        // eslint-disable-next-line no-else-return
        } else {
          hourStart = displayHour(dayData.hours[0].start);
          hourEnd = displayHour(dayData.hours[0].end);

          return `
            <li>
              <span class="day">${dayname}</span>
              <span class="schedule ${isSpecial}">
                ${hourStart} - ${hourEnd}
              </span>
            </li>
          `;
        }
      }
      let storeCloseMessage = 'woosmap.storepage.closing';
      if (dayData.isSpecial) {
        storeCloseMessage = 'woosmap.storepage.specialclosing';
      }

      return `
        <li>
          <span class="day">${dayname}</span>
          <span class="schedule scheduleSpecialHours">
          <p class="specialclosing-hours ${isSpecial}">
            ${i18n(storeCloseMessage)}
          <p>
          </span>

        </li>
        `;
    }



    const openings = Object.keys(dataStores[0].properties.weekly_opening).map(
      (key, index) => ({
        dayIndex: index,
        hours: dataStores[0].properties.weekly_opening[key].hours,
        isSpecial: dataStores[0].properties.weekly_opening[key].isSpecial,
      })
    );

    //deleted the last data (not hours)
    openings.splice(7, 1);

    openings.forEach(op => {
      $('.opening-days').append(displayDayOpening(op));
    });
  });
}



// WEBPACK FOOTER //
// ./src/store/store-page/storePageModule.js